import styled from '@emotion/styled';

const MFRButtonSpan = styled('span')({
  whiteSpace: 'nowrap',
});

export default MFRButtonSpan;
